import { CheckCircle2 } from "lucide-react";

const benefits = [
  "Specialister på träfasader",
  "Anpassad metod för varje trähus",
  "Miljövänliga färger av hög kvalitet",
  "UV-beständiga pigment för längre hållbarhet",
];

export default function ResultsSection() {
  return (
    <section className="section-padding bg-slate-900 text-white" data-testid="results-section">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="space-y-6">
            <span className="text-sm font-semibold tracking-wider uppercase text-[#b91c1c]">
              Resultat & Kvalitet
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
              Hållbart resultat för ditt trähus
            </h2>
            <p className="text-lg text-slate-300 leading-relaxed">
              Vi är specialister på träfasader och vet exakt vilken metod och vilket material 
              som passar just ditt hus. Vårt mål är alltid ett resultat som håller i många år.
            </p>
            
            <ul className="space-y-4 pt-4">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#b91c1c] flex-shrink-0" />
                  <span className="text-slate-200">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Images Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="rounded-2xl overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_9628547f-dbd1-447b-abd5-f19c4c5b0b86/artifacts/r7rcizuw_Fasadmalning%206.JPG"
                  alt="Slitet blått trähus före ommålning"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_9628547f-dbd1-447b-abd5-f19c4c5b0b86/artifacts/hcljkqyv_Fasadmalning%207.jpg"
                  alt="Nymålat ljusgrönt trähus efter fasadmålning"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
            <div className="space-y-4 pt-8">
              <div className="rounded-2xl overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_9628547f-dbd1-447b-abd5-f19c4c5b0b86/artifacts/nm9dx8it_Fasadmalning%204.jpg"
                  alt="Målare i arbete på gul träfasad"
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img 
                  src="https://customer-assets.emergentagent.com/job_9628547f-dbd1-447b-abd5-f19c4c5b0b86/artifacts/8ewxw6kd_Fasadmalning%201.jpg"
                  alt="Vi Målar Sverige bil på plats vid pågående fasadmålning"
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
